/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import NavigationItem from 'bundles/unified-seo-content-common/components/hub-page/NavigationItem';
import type { NavigationLinkWithSubItems } from 'bundles/unified-seo-content-common/types';
import { scrollPageToTop } from 'bundles/unified-seo-content-common/utils';

import _t from 'i18n!nls/articles';

type Props = {
  activeCategorySlug: string;
  navigationLinks: NavigationLinkWithSubItems[];
  onNavigationLinkClick?: () => void;
};

const styles = {
  styleForUnorderedListTag: css`
    list-style: none;
    margin: 0;
    padding-left: 0;
  `,
};

const Navigation = ({ activeCategorySlug, navigationLinks, onNavigationLinkClick }: Props) => {
  return (
    <nav role="navigation" aria-label={_t('Article Categories')}>
      <ul css={styles.styleForUnorderedListTag}>
        {navigationLinks?.map(({ slug, label, href, subNavigationLinks }) => {
          return (
            <li key={slug}>
              <NavigationItem
                label={label}
                href={href}
                slug={slug}
                subNavigationLinks={subNavigationLinks}
                activeCategorySlug={activeCategorySlug}
                onClick={onNavigationLinkClick || scrollPageToTop}
              />
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Navigation;
